import './LineOrnament.css'

export default function LineOrnament() {
    return (
        <div id='line_ornament'/>
    )
}